import { OwnerTransfer } from '@sorare/core/src/__generated__/globalTypes';
import { Auction } from '@sorare/core/src/atoms/icons/Auction';
import { InstantBuy } from '@sorare/core/src/atoms/icons/InstantBuy';
import { Shards } from '@sorare/core/src/atoms/icons/Shards';
import { Transfer } from '@sorare/core/src/atoms/icons/Transfer';
import type { Unit } from '@sorare/core/src/lib/style';

import { Pack } from '#src/components/transfers/Pack/index.tsx';
import { ReferralReward } from '#src/components/transfers/ReferralReward/index.tsx';
import { Reward } from '#src/components/transfers/Reward/index.tsx';

type Props = {
  transferType: OwnerTransfer;
  size?: Unit;
};

export const TokenTransferTypeIcon = ({ transferType, size = 2 }: Props) => {
  switch (transferType) {
    case OwnerTransfer.REFERRAL:
      return <ReferralReward size={size} />;
    case OwnerTransfer.REWARD:
      return <Reward size={size} />;
    case OwnerTransfer.SHARDS:
      return <Shards size={size} color="var(--c-green-400)" />;
    case OwnerTransfer.PACK:
    case OwnerTransfer.BUNDLED_ENGLISH_AUCTION:
      return <Pack size={size} color="var(--c-blue-300)" />;
    case OwnerTransfer.ENGLISH_AUCTION:
      return <Auction size={size} color="var(--c-blue-300)" />;
    case OwnerTransfer.INSTANT_BUY:
      return <InstantBuy size={size} color="var(--c-blue-300)" />;
    default:
      return <Transfer size={size} />;
  }
};
